// @flow

import React from 'react';
import {Loader} from '@xsolla/uikit';
import TableMessage from '../table-message';

const FetchingMessage = () => (
  <TableMessage>
    <Loader appearance="spinner" size="xlg" />
  </TableMessage>
);

export default FetchingMessage;
